import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import ExternalVerificationRepository from '@/repositories/ExternalVerificationRepository';
import { CreateInsuranceFromDiscoveredRequest } from '@/types/externalVerification';
import { InsurancePolicy } from '@/types/insurancePolicy';

export const useCreateInsuranceFromDiscoveredPolicy = (
  options?: MutationOptions<InsurancePolicy, AxiosError, CreateInsuranceFromDiscoveredRequest>
) => {
  const externalVerificationRepository = ExternalVerificationRepository();

  return useMutation({
    mutationFn: (data) => externalVerificationRepository.createInsuranceFromDiscoveredPolicy(data),
    ...options
  });
};

export default useCreateInsuranceFromDiscoveredPolicy;
